<template>
  <div class="bank">
    <div v-if="$store.state.userInfo.status !== 'ENABLED'" class="info-container">
      <verification-result :status="$store.state.userInfo.status"></verification-result>
    </div>
    <div v-else>
      <div v-if="['INITIAL','EDIT'].includes(bankStatus)">
        <md-field>
          <div class="form-group">
            <div class="form-label">{{ $t('bankLabel') }}</div>
            <select
              class="bank-code-select"
              v-model="bankForm.bankCode"
              ref="bank"
              name="bank"
              v-validate="'required'"
            >
              <optgroup disabled hidden></optgroup>
              <option v-for="option in bankList" :value="option.value" :key="option.value">
                {{ option.text }}
              </option>
            </select>
            <div v-if="errors.first('bank')" class="input-error">{{ errors.first('bank') }}</div>
            <!--<md-input-item-->
            <!--ref="bankCode"-->
            <!--name="bankCode"-->
            <!--:title="$t('bank')"-->
            <!--type="text"-->
            <!--is-title-latent-->
            <!--readonly-->
            <!--:placeholder="$t('bank')"-->
            <!--v-model="selectorText.bankCode"-->
            <!--v-validate="'required'"-->
            <!--@focus="showSelector('bankCode')"-->
            <!--:error="errors.first('bank')"-->
            <!--&gt;-->
            <!--</md-input-item>-->
          </div>
          <div class="form-group">
            <div class="form-label">{{ $t('bankAccountLabel') }}</div>
            <md-input-item
              name="accountNumber"
              ref="accountNumber"
              placeholder=""
              type="bankCard"
              class="bordered"
              v-model="bankForm.accountNumber"
              v-validate="'required'"
              :error="errors.first('accountNumber')"
            >
            </md-input-item>
          </div>
        </md-field>
        <!--<md-selector-->
        <!--class="bank-selector"-->
        <!--v-model="selectorVisible.bankCode"-->
        <!--:data="bankList"-->
        <!--cancel-text="cancel"-->
        <!--title="Banks"-->
        <!--@choose="onSelectorChoose($event, 'bankCode')"-->
        <!--&gt;</md-selector>-->
        <div class="btn-save">
          <md-button type="primary" round @click="changeBank">
            {{ $t('save') }}
          </md-button>
        </div>
        <div class="btn-cancel" v-if="bankStatus === 'EDIT'">
          <md-button type="primary" round plain @click="toggleBankFormStatus('PASSED')">
            {{ $t('cancel') }}
          </md-button>
        </div>
      </div>
      <div v-if="bankStatus === 'PENDING'" class="bank-pending">
        <img src="@/assets/image/icons/icon-pending.png">
        <div class="title">{{ $t('pendingTitle') }}</div>
        <div class="desc">{{ $t('pendingDesc') }}</div>
      </div>
      <div v-if="bankStatus === 'PASSED'" class="bank-passed" @click="toggleBankFormStatus('EDIT', true)">
        <div class="bank-card">
          <div class="bank-name">
            <div class="value">{{ bankForm.bankName }}</div>
            <div class="label">{{ $t('bankLabel') }}</div>
          </div>
          <div class="bank-number">
            <div>
              <div class="value">{{ bankForm.accountNumber }}</div>
              <div class="label">{{ $t('bankAccountLabel') }}</div>
            </div>
            <div>
              <img src="@/assets/image/icons/icon-edit.png">
            </div>
          </div>
        </div>
      </div>
      <div v-if="['INVALID','MISMATCH','FAILED'].includes(bankStatus)" class="bank-failed">
        <div class="failed-icon">
          <img src="@/assets/image/icons/icon-attention.png">
        </div>
        <div class="failed-desc">{{ failedDesc }}</div>
        <div class="btn-retry">
          <md-button type="primary" round @click="toggleBankFormStatus('INITIAL', true)">{{ $t('retry') }}</md-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Field, InputItem, Selector, Button } from 'mand-mobile'
import VerificationResult from '@/components/common/VerificationResult'

export default {
  i18n: {
    messages: {
      en: {
        bankLabel: 'Bank',
        bankAccountLabel: 'Bank Account',
        accountName: 'Account Name',
        accountNumber: 'Account Number',
        responseSUCCESS: 'Bind successfully',
        save: 'Save',
        cancel: 'Cancel',
        pendingTitle: 'Verifying...',
        pendingDesc: 'Please be patient, the data is being processed.',
        mismatchDesc: 'Name on your bank account is different with your KTP. If you need any help, please contact pendanaan@kreditpintar.com',
        invalidDesc: 'Invalid bank account, if you need any help please contact pendanaan@kreditpintar.com',
        retry: 'Try Again',
      },
      id: {
        bankLabel: 'Bank',
        bankAccountLabel: 'Bank Account',
        accountName: 'Nama Pemilik Akun',
        accountNumber: 'No. Rekening',
        responseSUCCESS: 'Bind berhasil',
        save: 'Simpan',
        cancel: 'Cancel',
        pendingTitle: 'Memverifikasi...',
        pendingDesc: 'Harap bersabar, data sedang diproses',
        mismatchDesc: 'Nama di akun bank Anda tidak sesuai dengan KTP, jika Anda memerlukan bantuan silahkan hubungi pendanaan@kreditpintar.com',
        invalidDesc: 'Akun bank tidak valid, jika Anda memerlukan bantuan silahkan hubungi pendanaan@kreditpintar.com',
        retry: 'Coba Lagi',
      },
    },
  },
  components: {
    [Field.name]: Field,
    [InputItem.name]: InputItem,
    [Selector.name]: Selector,
    [Button.name]: Button,
    VerificationResult,
  },
  data() {
    const info = this.$store.state.userInfo
    const bankList = [
      { text: 'Bank Central Asia', value: 'BCA' },
      { text: 'Bank Negara Indonesia', value: 'BNI' },
      { text: 'Bank Rakyat Indonesia', value: 'BRI' },
      { text: 'Bank Mandiri', value: 'MANDIRI' },
      { text: 'Bank Permata', value: 'PERMATA' },
      { text: 'Bank DKI', value: 'DKI' },
      { text: 'Bank Danamon Indonesia', value: 'DANAMON' },
      { text: 'Bank CIMB Niaga', value: 'CIMB' },
      { text: 'Bank ANZ Indonesia', value: 'ANZ' },
      { text: 'Bank Mayapada Internasional', value: 'MAYAPADA' },
      { text: 'Bank Maybank Syariah Indonesia', value: 'MAYBANK_SYR' },
      { text: 'Bank OCBC NISP', value: 'OCBC' },
      { text: 'Bank Bukopin', value: 'BUKOPIN' },
      { text: 'Bank UOB Indonesia', value: 'UOB' },
      { text: 'Bank Tabungan Negara (Persero)', value: 'BTN' },
      { text: 'Bank ICBC Indonesia', value: 'ICBC' },
      { text: 'Bank MEGA', value: 'MEGA' },
      { text: 'Bank Sinarmas', value: 'SINARMAS' },
      { text: 'Bank Tabungan Pensiunan National', value: 'TABUNGAN_PENSIUNAN_NASIONAL' },
      { text: 'Bank Panin', value: 'PANIN' },
      { text: 'Bank DBS Indonesia', value: 'DBS' },
    ]
    return {
      bankList: bankList,
      selectorVisible: {
        bankCode: false,
      },
      selectorText: {
        bankCode: '',
      },
      bankForm: {
        bankCode: info.bankCode || '',
        bankName: info.bankName ? info.bankName : info.bankCode ? bankList.find(i => i.value === info.bankCode).text : '--',
        accountNumber: info.bankAccountNumber,
      },
      bankStatus: info.bankAccountStatus || 'INITIAL',
    }
  },
  watch: {
    userInfo: function(newVal, oldVal) {
      this.bankStatus = newVal.bankAccountStatus || 'INITIAL'
      this.bankForm.bankName = newVal.bankName ? newVal.bankName : newVal.bankCode ? this.bankList.find(i => i.value === newVal.bankCode).text : '--'
      this.bankForm.bankCode = newVal.bankCode || ''
    },
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo
    },
    failedDesc() {
      return this.bankStatus === 'MISMATCH' ? this.$t('mismatchDesc') : this.$t('invalidDesc')
    },
  },
  async mounted() {
  },
  methods: {
    showSelector(name) {
      this.selectorVisible[name] = true
    },
    onSelectorChoose({ text, value }, name) {
      this.selectorText[name] = text
      this.bankForm[name] = value
    },
    async changeBank() {
      try {
        const result = await this.$validator.validateAll()
        if (result) {
          const bankCode = this.bankForm.bankCode
          const payload = {
            bankCode: bankCode,
            bankName: this.bankList.find(i => i.value === bankCode).text,
            accountNumber: this.bankForm.accountNumber,
          }
          this.$toast.loading('loading...')
          const response = await this.$http.post('/investor/edit-bank-account', payload)
          const data = response.data.data
          const bankStatus = data && data.accountStatus ? data.accountStatus : 'EDIT'
          this.bankStatus = bankStatus
          if (bankStatus === 'PASSED') {
            this.$toast.succeed(this.$t('responseSUCCESS'))
          }
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.$toast.hide()
      }
    },
    resetBankInfo(ifClear) {
      const info = this.userInfo
      if (ifClear) {
        this.bankForm.bankCode = ''
        this.bankForm.accountNumber = ''
      } else {
        this.bankForm.bankCode = info.bankCode
        this.bankForm.bankName = info.bankName ? info.bankName : (info.bankCode ? this.bankList.find(i => i.value === info.bankCode).text : '--')
        this.bankForm.accountNumber = info.bankAccountNumber
      }
    },
    toggleBankFormStatus(status, ifClear) {
      this.bankStatus = status
      this.resetBankInfo(ifClear)
    },
  },
}
</script>

<style lang="stylus" scoped>
.bank {
  padding: 30px 0;
}

.form-group {
  margin-bottom: 20px;
  .form-label {
    margin-bottom: 8px;
    color: #555;
    font-size: 12px;
  }
}

.bank-code-select {
  width: 100%;
  height: 40px;
  outline: none;
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  border: 1px solid #ccc;
  background: unset;
  padding: 0 10px;
}

.input-error {
  margin-top: 5px;
  color: #ff525d;
  font-size: 12px;
}

.btn-cancel /deep/ {
  margin-top: 20px;
  .md-button {
    width: 100%;
  }
}

.bank-pending {
  padding: 20px 30px;
  text-align: center;
  .title {
    font-size: 20px;
    margin-top: 20px;
    line-height: 1.25em;
    font-weight: bold;
  }
  .desc {
    font-size: 14px;
    line-height: 1.25em;
  }
}

.bank-card {
  background: url('../../../assets/image/user/bank-card-bg.png');
  background-size: cover;
  padding: 20px;
  border: 1px dashed #ccc;
  .value {
    font-size: 16px;
    font-weight: bold;
  }
  .label {
    color: #555;
    font-size: 12px;
    line-height: 1.25em;
  }
  .bank-name {
    margin-bottom: 20px;
  }
  .bank-number {
    display: flex;
    justify-content: space-between;
  }
}

.bank-failed {
  text-align: center;
  padding: 30px 10px 10px;
  .failed-icon img {
    width: 60px;
    height: 60px;
  }
  .failed-desc {
    font-size: 16px;
    line-height: 1.25em;
    font-weight: bold;
    margin: 20px 0;
  }
}

</style>
